const Index = resolve => {
  require.ensure(["./index.vue"], () => {
    resolve(require("./index.vue"))
  }, "notifications")
}

export default class NotificationsRouter {

    static addRoutes(appRoutes) {

      appRoutes.push({ path: "notifications", component: Index })
    }
}
